import { render } from "./AdminTextarea.vue?vue&type=template&id=e62afb54"
import script from "./AdminTextarea.vue?vue&type=script&lang=js"
export * from "./AdminTextarea.vue?vue&type=script&lang=js"

import "./AdminTextarea.vue?vue&type=style&index=0&id=e62afb54&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__